import { useAction, useAtom } from "@reatom/npm-react";
import s from "./style.module.scss";
import {
  currentServiceAtom,
  currentServiceIsLoadingAtom,
} from "../../core/reatom/state/currentService/currentService";
import { UserLine } from "../UserLine/UserLine";
import { Description } from "../Description/Description";
import { Block } from "../Block/Block";
import clsx from "clsx";
import { Skeleton } from "@vkontakte/vkui";

import { SwiperImages } from "../SwiperImages/SwiperImages";
import { useNavigate } from "react-router";
import { freelanceAction } from "@/core/reatom/state/search";

export const CardDescription = () => {
  const [currentService] = useAtom(currentServiceAtom);
  const navigate = useNavigate();
  const [isLoadingAtom] = useAtom(currentServiceIsLoadingAtom);
  const handleSearchFreelancer = useAction(freelanceAction);
  const fetchFreelancer = () => {
    if (!currentService?.user.id) return;
    handleSearchFreelancer({ user_id: currentService?.user.id });
  };

  return (
    <div className={s.wrapper}>
      {isLoadingAtom ? (
        <div className={clsx(s.img, s.mobileImg)}>
          <Skeleton className={clsx(s.img, s.desktopImg)} />
        </div>
      ) : (
        <div className={clsx(s.img, s.mobileImg)}>
          <SwiperImages />
        </div>
      )}
      {isLoadingAtom ? (
        <div>
          <Skeleton height={50} />
        </div>
      ) : (
        <p className={s.title}>{currentService?.title}</p>
      )}

      <UserLine
        onClick={() => {
          fetchFreelancer();

          navigate("/freelancer/" + currentService?.user.id);
        }}
      />
      <Description
        autoExpand
        description={currentService?.description}
        isLoading={isLoadingAtom}
        files={currentService?.files}
        result={currentService?.emp_result}
        requirements={currentService?.emp_requirement}
        date_post={currentService?.date_post}
        date_edit={currentService?.date_edit}
      />
    </div>
  );
};

export const ImageDesktop = () => {
  const [isLoadingAtom] = useAtom(currentServiceIsLoadingAtom);

  return (
    <Block borderRadius="bottom" className={s.imageDesctopWrapper}>
      {isLoadingAtom ? (
        <div className={clsx(s.img, s.desktopImg)}>
          <Skeleton className={clsx(s.img, s.desktopImg)} />
        </div>
      ) : (
        <div className={s.desktopImg}>
          <SwiperImages />
        </div>
      )}
    </Block>
  );
};
